import { state } from "@angular/animations";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { UrlModal } from "src/app/shared/url.model";

@Injectable({
  providedIn: "root",
})
export class LabService {
  constructor(private httpClient: HttpClient) {}

  saveLabToDatabase(data, token: string) {
    return this.httpClient.post(UrlModal._URL + "/lab/addlab", data, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }
  updatelabToDatabase(
    data,
    token: string
  ) {
    return this.httpClient.post(UrlModal._URL + "/lab/updatelab", data, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }

  getlabFromDb(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    console.log(params);
    return this.httpClient
      .get<labData>(UrlModal._URL + "/lab/getlabs/", {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
        params: params,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  deletelab(id, token) {
    return this.httpClient.post(
      UrlModal._URL + "/lab/deletelab/",
      {
        id: id,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  getSinglelab(id, token) {
    return this.httpClient.post<singlelabData>(
      UrlModal._URL + "/lab/singlelab",
      {
        id: id,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  addlabImages(title, image, id, token) {
    var formData = new FormData();
    const files: Array<File> = image;

    files.forEach((sinImg, index) => {
      formData.append("labimage", sinImg, sinImg.name);
      formData.append("labdesc", title[index].imagetitle);
    });
    formData.append("id", id);

    return this.httpClient.post(UrlModal._URL + "/lab/addlabimages", formData, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }
}
export interface labData {
  status: number;
  message: string;
  labs: {
    docs: [
      {
        _id: string;
        name: string;
        email: string;

        address: {
          line1: string;
          city: string;
          pincode: number;
          state: string;
        };
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}
export interface singlelabData {
  status: number;
  message: string;
  labs: {
    _id: string;
    name: string;
    email: string;
    laTiming: {
      startTime: string;
      endTime: string;
    };
    description: string;
    address: {
      line1: string;
      city: string;
      pincode: number;
      state: string;
    };
    services: [
      {
        _id: string;
        serviceName: string;
        price: string;
      }
    ];
    registrationNo: number;
    labImages: [];
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
